





























import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";

export default Vue.extend({
    components: {
        iwModal: iwModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        cancel: function() {
            this.$emit("cancel");
        },
        confirm: function() {
            this.$emit("confirm");
        },
    },
});
